<template>
  <button class="del-cross" @click.stop="remove" type="button">
    <span></span>
  </button>
</template>

<script>
export default {
  props: [],
  methods: {
    remove() {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/base/_colors.scss' as *;

.del-cross {
  position: relative;
  border: none;
  padding: 0;
  height: 20px;
  width: 20px;

  span,
  span:after {
    display: block;
    margin: auto;
    position: absolute;
    background-color: $grey-l;
  }

  span {
    transform: rotate(45deg);
    height: 2px;
    left: 5px;
    top: 10px;
    width: 10px;
  }

  span:after {
    content: '';
    height: 10px;
    left: 4px;
    top: -4px;
    width: 2px;
  }

  &:hover {
    span,
    span:after {
      background-color: $rijnja-red;
    }
  }
}
</style>
